import {AirResponse} from './air.response.model';
import {Artifact} from './artifact.model';

export class Part {
  partType: string;
  partId: string;
  viewerCode: string;
  mimeCode: string;
  uri: string;
  uriSrcType: string;
  waveFormUri: string;
  data: string;
  comment: string;
  airResponse: AirResponse;
  artifactsList?: Artifact[];
}
